export const IMPORT_UI_CHECKS = [
  {
    id: 'file',
    label:
      'SEIS, schedule, contacts and 504 files read on selection; file summary and optional preview work'
  },
  {
    id: 'school',
    label:
      'Wrong-school file is blocked; changing schools clears the review and does not move saved status'
  },
  {
    id: 'review',
    label:
      'Import source and Setup preserve the review; steps and action buttons stay visible on a short screen. 504 search, filters and collapse preserve choices; bulk choices apply to hidden students too'
  },
  {
    id: 'confirm',
    label:
      '504 cannot import before Confirm all changes; school, file, skipped students and changes are correct'
  },
  {
    id: 'back',
    label: 'Back keeps choices; changing a conflicting choice requires acknowledgment again'
  },
  {
    id: 'reopen',
    label:
      'Synthetic student reopens with approved changes; overview status survives refresh in the correct school'
  },
  {
    id: 'undo',
    label:
      'Reopened 504 wizard offers Undo; previous values return and overview says Previous values restored'
  }
]

export function importUiResults(checked = {}) {
  return IMPORT_UI_CHECKS.map((check) => ({
    scenario: 'importUiReview',
    step: `Manual UI: ${check.label}`,
    status: checked[check.id] === true ? 'pass' : 'blocked',
    durationMs: 0,
    detail:
      checked[check.id] === true
        ? 'Operator marked this check verified in the browser'
        : 'Not yet verified by the operator'
  }))
}

const STORAGE_KEY = 'cmv-import-ui-smoke-review'
// Keep progress while the runner is closed to use the wizard; invalidate it
// when a newly built JS chunk loads so an old review cannot pass a new build.
export function loadImportUiChecks(buildId) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null')
    return saved?.buildId === buildId ? saved.checks || {} : {}
  } catch {
    return {}
  }
}

export function saveImportUiChecks(buildId, checks) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ buildId, checks }))
}
